// Controlled vocabulary suggested in the form-template pickers/filters.
//
// Two distinct axes, following standard clinical-documentation taxonomies
// (cf. NUCC/ABMS provider taxonomy, WHO standardized clinical forms):
//   - CATEGORIES describe the form's PURPOSE/TYPE along the care workflow.
//   - TAGS are cross-cutting FACETS (medical specialty, clinical topic, compliance).
// The DB stores these stable English keys; ./vocabularyLabels.ts renders them per locale.

// Form type, ordered along the clinical workflow (intake → ... → discharge).
export const DEFAULT_FORM_CATEGORIES = [
  'intake',
  'history',
  'screening',
  'assessment',
  'diagnosis',
  'treatment-plan',
  'consultation',
  'follow-up',
  'pre-op',
  'post-op',
  'consent',
  'referral',
  'prescription',
  'discharge',
  'prevention',
  'ethics',
]

export const DEFAULT_FORM_TAGS = [
  // Medical specialties (NUCC/ABMS)
  'general-practice',
  'cardiology',
  'dermatology',
  'pediatrics',
  'psychiatry',
  'gynecology',
  'neurology',
  'ophthalmology',
  'orthopedics',
  'endocrinology',
  'gastroenterology',
  'ent',
  // Clinical topics
  'symptoms',
  'pain',
  'medication',
  'allergy',
  'vitals',
  'lifestyle',
  'nutrition',
  'mental-health',
  'chronic-disease',
  'vaccination',
  'pregnancy',
  'family-history',
  // Compliance / regulatory (France teleconsultation, GDPR, ethics)
  'france',
  'gdpr',
  'consent',
  'teleconsultation',
  'ai',
  'recording',
  'privacy',
  'data-sharing',
  'secondary-use',
  'autonomy',
]
